// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const WIKI_REVIEW_CATEGORY__MORE_ARTICLE_PREVIEWS = "V\u00edce produkt\u016f...";
